// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Fj6N","signatureBlock":"Footer_signatureBlock__3J0Vr","signature":"Footer_signature__31eMA"};